// extracted by mini-css-extract-plugin
export default {"referralComponent":"FV","greyBack":"GV","greenBack":"HV","greenText":"IV","explainText":"JV","spinner":"KV","storedText":"LV"};
    if(module.hot) {
      // 1711717534725
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  